import styled from 'styled-components'

export default styled.div`
  max-width: 100vw;
  max-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: -1;
`



// WEBPACK FOOTER //
// ./src/components/VideoWrapper.js